
export default function Gallery() {
  const galleryImages = [
    {
      url: 'https://public.readdy.ai/ai/img_res/60e8d1179b8707bfd00a685c918af6f5.jpg',
      title: 'Exterior Detailing'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Clean%20pristine%20car%20interior%20with%20leather%20seats%20perfectly%20conditioned%20and%20dashboard%20spotless%2C%20professional%20detailing%20result%2C%20simple%20clean%20background%20with%20green%20and%20yellow%20accents%2C%20luxury%20automotive%20interior%20care&width=600&height=400&seq=gallery-2&orientation=landscape',
      title: 'Interior Perfection'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Car%20headlights%20crystal%20clear%20after%20restoration%20treatment%20showing%20before%20and%20after%20comparison%2C%20professional%20automotive%20lighting%20restoration%2C%20clean%20simple%20background%20with%20green%20yellow%20tones%2C%20detailed%20close-up%20shot&width=600&height=400&seq=gallery-3&orientation=landscape',
      title: 'Headlight Restoration'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Ceramic%20coating%20being%20applied%20to%20car%20paint%20surface%20with%20professional%20applicator%2C%20protective%20layer%20treatment%2C%20clean%20workshop%20environment%20with%20green%20yellow%20color%20scheme%2C%20automotive%20paint%20protection%20process&width=600&height=400&seq=gallery-4&orientation=landscape',
      title: 'Paint Protection'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Spotless%20clean%20engine%20bay%20after%20professional%20detailing%20and%20degreasing%2C%20organized%20and%20pristine%20mechanical%20components%2C%20simple%20clean%20background%20with%20green%20yellow%20accents%2C%20automotive%20engine%20compartment%20cleaning&width=600&height=400&seq=gallery-5&orientation=landscape',
      title: 'Engine Bay Cleaning'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Complete%20vehicle%20transformation%20showing%20full%20detail%20package%20results%2C%20gleaming%20car%20in%20professional%20setting%2C%20clean%20simple%20background%20with%20green%20and%20yellow%20tones%2C%20before%20and%20after%20automotive%20detailing%20showcase&width=600&height=400&seq=gallery-6&orientation=landscape',
      title: 'Complete Transformation'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-gray-900">Our Work</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            See the difference professional detailing makes. Every vehicle gets our complete attention to detail.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((image, index) => (
            <div 
              key={index}
              className="relative overflow-hidden rounded-xl shadow-lg group cursor-pointer"
            >
              <img 
                src={image.url}
                alt={image.title}
                className="w-full h-80 object-cover object-top transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <div className="p-6 text-white">
                  <h3 className="text-xl font-bold">{image.title}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
